<template>
  <div class="commitment-modal-container">
    <div class="content-container">
      <div class="close-icon" @click="close()">
        <svg width="33" height="33" viewBox="0 0 33 33" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M16.5 33c4.548 0 8.435-1.613 11.661-4.839C31.387 24.935 33 21.048 33 16.5c0-4.548-1.613-8.435-4.839-11.661C24.935 1.613 21.048 0 16.5 0 11.952 0 8.065 1.613 4.839 4.839 1.613 8.065 0 11.952 0 16.5c0 4.548 1.613 8.435 4.839 11.661C8.065 31.387 11.952 33 16.5 33zm0-1.428c-4.23 0-7.8-1.454-10.71-4.363C2.883 24.3 1.429 20.731 1.429 16.5c0-4.23 1.454-7.8 4.363-10.71C8.7 2.883 12.269 1.429 16.5 1.429c4.23 0 7.8 1.454 10.71 4.363 2.908 2.909 4.362 6.478 4.362 10.709 0 4.23-1.454 7.8-4.363 10.71-2.909 2.908-6.478 4.362-10.709 4.362zm6.663-7.457l.952-.952-6.663-6.663 6.663-6.663-.952-.952-6.663 6.663-6.663-6.663-.952.952 6.663 6.663-6.663 6.663.952.952 6.663-6.663 6.663 6.663z" fill="#000" fill-rule="nonzero"/></svg>
      </div>

      <div class="commitment-item">
        <button v-if="changesExist" class="green" @click="sendCommitmentUpdates()">Save Commitment</button>
        <button
          v-if="changesExist"
          class="green"
          @click="formValues = commitment; changesExist = false;"
        >Reset</button>

        <div class="description-content">
          <div class="container-row">
            <div class="flex-col organization-col">
              <div class="item-group">
                <div class="item-label">Sewist Information</div>

                <div class="flex-col">
                  <div class="form-value">
                    <input
                      v-on:change="changesExist = true"
                      :placeholder="'First Name'"
                      v-model="formValues.firstName"
                      type="text"
                    />
                    <div v-if="errors.firstName" class="error">***</div>

                    <input
                      v-on:change="changesExist = true"
                      :placeholder="'Last Name'"
                      v-model="formValues.lastName"
                      type="text"
                    />
                    <div v-if="errors.lastName" class="error">***</div>
                  </div>
                  <input
                    v-on:change="changesExist = true"
                    :placeholder="'Email'"
                    v-model="formValues.email"
                    type="text"
                  />
                  <div v-if="errors.email" class="error">***</div>

                  <input
                    v-on:change="changesExist = true"
                    :placeholder="'Phone Number'"
                    v-model="formValues.phoneNumber"
                    type="text"
                  />
                  <div v-if="errors.phoneNumber" class="error">***</div>
                </div>
              </div>

              <div v-if="global.screenWidth >= 1008" class="item-group">
                <div class="item-label">Current Status:</div>

                <Dropdown
                  :className="'dashboard-dd'"
                  :options="commitmentStatusList"
                  :initialItem="commitmentStatusList.find( (status) => status.key === commitment.commitmentStatus)"
                  @itemselected="(newStatus) => setEditedField('commitmentStatus', newStatus.key)"
                />
              </div>
            </div>
            <div class="flex-col request-details-col">
              <div class="section-label">Commitment Details</div>
              <div class="flex-row flex-wrap ppe-items">
                <div class="ppe-item">
                  <div class="quantity">
                    <input
                      v-on:change="changesExist = true"
                      :placeholder="0"
                      v-model="formValues.masks"
                      class="numberinput"
                      type="number"
                      min="0"
                    />
                    /
                    <b>{{request.masks}}</b>
                  </div>
                  <div class="title">
                    Masks
                    <div
                      v-if="errors.masks"
                      class="error"
                    >{{typeof errors.masks === 'string' ? errors.masks : '***'}}</div>
                  </div>
                </div>
                <div class="ppe-item">
                  <div class="quantity">
                    <input
                      v-on:change="changesExist = true"
                      :placeholder="0"
                      v-model="formValues.caps"
                      class="numberinput"
                      type="number"
                      min="0"
                    />
                    /
                    <b>{{request.caps}}</b>
                  </div>
                  <div class="title">
                    Caps
                    <div
                      v-if="errors.caps"
                      class="error"
                    >{{typeof errors.caps === 'string' ? errors.caps : '***'}}</div>
                  </div>
                </div>

                <div class="ppe-item">
                  <div class="quantity">
                    <input
                      v-on:change="changesExist = true"
                      :placeholder="0"
                      v-model="formValues.other"
                      class="numberinput"
                      type="number"
                      min="0"
                    />
                    /
                    <b>{{request.other}}</b>
                  </div>
                  <div class="title">
                    Other
                    <div
                      v-if="errors.other"
                      class="error"
                    >{{typeof errors.other === 'string' ? errors.other : '***'}}</div>
                  </div>
                </div>
              </div>

              <div class="f-row">
                <div class="item-group additional-notes">
                  <div class="item-label">Additional Notes</div>
                  <div class="form-value">
                    <textarea
                      v-on:change="changesExist = true"
                      :placeholder="'Additional Notes'"
                      v-model="formValues.additionalNotes"
                      type="text"
                      maxlength="300"
                    />
                  </div>
                </div>
                <div class="item-group additional-notes">
                  <div class="item-label">Admin Notes</div>
                  <div class="form-value">
                    <textarea
                      v-on:change="changesExist = true"
                      :placeholder="'Admin Notes'"
                      v-model="formValues.adminNotes"
                      type="text"
                      maxlength="300"
                    />
                  </div>
                </div>
              </div>
              <div v-if="global.screenWidth < 1008" class="item-group">
                <div class="item-label">Current Status:</div>

                <Dropdown
                  :className="'dashboard-dd'"
                  :options="commitmentStatusList"
                  :initialItem="commitmentStatusList.find( (status) => status.key === commitment.commitmentStatus)"
                  @itemselected="(newStatus) => setEditedField('commitmentStatus', newStatus.key)"
                />
                <button
                  v-if="changesExist"
                  class="green"
                  @click="sendCommitmentUpdates()"
                >Save Commitment</button>
                <button
                  v-if="changesExist"
                  class="green"
                  @click="formValues = commitment; changesExist = false;"
                >Reset</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import fire from "@/config/fire.js";
import axios from "axios";
import { mapActions, mapState } from "vuex";
import Dropdown from "@/components/global/Dropdown";
import { statusConstants } from "@/data/statusConstants";
import { validationHelper } from "@/helpers";
export default {
  name: "CommitmentModal",
  components: {
    Dropdown,
  },
  props: {
    commitment: {
      type: Object,
      required: true,
    },
    request: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState(["global"]),
  },
  data() {
    return {
      commitmentStatusList: Object.keys(statusConstants().commitment).map(
        (status) => {
          return { label: status, key: status };
        }
      ),
      formValues: {},
      changesExist: false,
      errors: {},
    };
  },

  mounted() {
    document.documentElement.style.overflow = "hidden";
    this.formValues = JSON.parse(JSON.stringify(this.commitment));
  },
  beforeDestroy() {
    document.documentElement.style.overflow = "auto";
  },
  methods: {
    close() {
      this.$emit("closeCommitmentModal");
    },
    sendCommitmentUpdates() {
      this.errors = {};

      if (!this.commitment.commitmentId) {
        this.$swal("Error!", "Please try again later", "error");
      }
      if (this.checkEmpties()) {
        this.$swal(
          "Error!",
          "Please correct the indicated field(s) and try your submission again.",
          "error"
        );
        return;
      }

      // fire.auth().onAuthStateChanged(user => {
      this.getFireIdToken()
        .then((idToken) => {
          if (!idToken) return;
          axios.defaults.headers.common["Authorization"] = idToken;
          const url = process.env.VUE_APP_BASE_URL + "/api/updateCommitment";
          return axios({
            method: "post",
            url: url,
            headers: { Authorization: idToken },
            data: {
              commitmentId: this.commitment.commitmentId,
              formValues: this.formValues,
            },
          });
        })
        .then((res) => {
          if (res.data && res.data.status === "success") {
            this.changesExist = false;
            this.setUserData(res.data.userData);
            this.$swal(
              "Success!",
              "You have updated the commitment!",
              "success"
            );
          } else {
            this.$swal("Error!", "Please try again later", "error");
          }
        });
      // });
    },
    setEditedField(fieldName, value) {
      this.changesExist = true;
      this.formValues[fieldName] = value;
    },
    getFireIdToken() {
      return fire.auth().currentUser.getIdToken();
    },
    checkEmpties() {
      let emptiesExist = false;

      if (
        !this.formValues.firstName ||
        this.formValues.firstName.trim() === ""
      ) {
        emptiesExist = true;
        this.errors = {
          ...this.errors,
          firstName: true,
        };
      }
      if (!this.formValues.lastName || this.formValues.lastName.trim() === "") {
        emptiesExist = true;
        this.errors = {
          ...this.errors,
          lastName: true,
        };
      }
      if (
        !this.formValues.email ||
        this.formValues.email.trim() === "" ||
        !validationHelper.validateEmail(this.formValues.email)
      ) {
        emptiesExist = true;
        this.errors = {
          ...this.errors,
          email: true,
        };
      }
      if (
        !this.formValues.phoneNumber ||
        this.formValues.phoneNumber.trim() === "" ||
        !validationHelper.validatePhone(this.formValues.phoneNumber)
      ) {
        emptiesExist = true;
        this.errors = {
          ...this.errors,
          phoneNumber: true,
        };
      }

      if (
        this.formValues.masks === 0 &&
        this.formValues.caps === 0 &&
        this.formValues.other === 0
      ) {
        emptiesExist = true;
        this.errors = {
          ...this.errors,
          masks: true,
          caps: true,
          other: true,
        };
      }

      if (this.formValues.masks > parseInt(this.request.masks)) {
        emptiesExist = true;
        this.errors = {
          ...this.errors,
          masks: "You cannot commit more than is outstanding",
        };
      }
      if (this.formValues.caps > parseInt(this.request.caps)) {
        emptiesExist = true;
        this.errors = {
          ...this.errors,
          caps: "You cannot commit more than is outstanding",
        };
      }
      if (this.formValues.other > parseInt(this.request.other)) {
        emptiesExist = true;
        this.errors = {
          ...this.errors,
          other: "You cannot commit more than is outstanding",
        };
      }
      if (this.formValues.masks < 0) {
        emptiesExist = true;
        this.errors = {
          ...this.errors,
          masks: "Qty cannot be negative.",
        };
      }
      if (this.formValues.caps < 0) {
        emptiesExist = true;
        this.errors = {
          ...this.errors,
          caps: "Qty cannot be negative.",
        };
      }
      if (this.formValues.other < 0) {
        emptiesExist = true;
        this.errors = {
          ...this.errors,
          other: "Qty cannot be negative.",
        };
      }
      return emptiesExist;
    },
    ...mapActions(["setUserData"]),
  },
};
</script>


<style lang="scss" scoped>
.error {
  color: red;
}
.commitment-modal-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  max-width: 100vw;
  z-index: 5;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow-y: auto;
  overflow-x: hidden;

  .close-icon {
    position: relative;
    bottom: 10px;
    left: 10px;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    padding: 15px;
    cursor: pointer;
  }
  .content-container {
    overflow-y: auto;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
    background: #fff;
    width: 90%;
    position: absolute;
    top: 150px;
    border-radius: 2px;
  }

  .title {
    display: flex;
    align-items: center;
    justify-content: left;
    width: 100%;
  }
  .commitment-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 16px;
    max-width: 100vw;
  }
  .edit-btn {
    margin: 0;
    @media (min-width: $md) {
      margin: 10px 0 0 10px;
    }
  }

  .description {
    height: 100%;
    font-size: 14px;
    color: #000000;
    .bold {
    }
  }
  .description-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #ffffff;
    border-bottom: 1px solid #efefef;
    padding: 24px 20px;
    max-width: 100vw;
    // .description {
    //   width: 625px;
    //   max-width: 100vw;
    // }
    @media (max-width: $lg) {
      padding: 15px 25px;
    }
    @media (max-width: $md) {
      padding: 5px 15px;
    }
    input {
      margin: 5px 0;
      border: 0;
    }
    textarea {
      width: 100%;
      height: 85px;
      border: 0;
    }
    .numberinput {
      width: 80px;
      margin-right: -10px;
    }
  }

  .container-row {
    display: flex;
    flex-direction: row;
    width: 100%;
    padding: 16px;
    max-width: 100vw;
    @media (max-width: $lg) {
      flex-direction: column;
    }
  }
  .flex-col {
    display: flex;
    flex-direction: column;
  }
  .flex-row,
  .f-row {
    display: flex;
    flex-direction: row;
    @media (max-width: $md) {
      flex-direction: column;
    }
  }
  .flex-center {
    justify-content: center;
    align-items: center;
  }
  .flex-wrap {
    flex-wrap: wrap;
  }
  .flex-grow {
    flex-grow: 1;
  }
  .ppe-items {
    max-width: 100%;
    justify-content: flex-start;

    @media (max-width: $md) {
      flex-direction: column !important;
    }
    .ppe-item {
      margin-right: 50px;
      @media (max-width: $lg) {
        margin: auto 12px;
      }
      @media (max-width: $md) {
        margin: auto;
      }
      .quantity {
        font-size: 33px;
        color: #003900;
        letter-spacing: 0px;
        line-height: 40px;
        @media (max-width: $lg) {
          font-size: 26px;
        }
        @media (max-width: $md) {
          font-size: 22px;
        }
        b {
          color: #2ec693;
        }
      }
      .title {
        opacity: 0.5;
        font-size: 14px;
        color: #8b8795;
        letter-spacing: 0;
      }
    }
  }

  .organization-col {
    width: 320px;
    max-width: 100vw;
    border-right: 1px solid #efefef;
    padding: 0 25px;
    @media (max-width: $md) {
      padding: 0;
      border-right: none;
    }
  }
  .request-details-col {
    flex-grow: 1;
    padding-left: 35px;
    @media (max-width: $md) {
      padding-left: 0;
      margin-top: 25px;
    }
  }

  .item-group {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 0 15px 0 0;
    margin-top: 35px;
    @media (max-width: $md) {
      padding: 8px;
    }
    &.additional-notes {
      &:first-child {
        border-right: 1px solid #efefef;
      }
      &:nth-child(2) {
        @media (min-width: $md) {
          padding: 0 8px 0 35px;
        }
      }
    }
  }
  .item-label {
    opacity: 0.7;
    font-size: 14px;
    color: #8b8795;
    letter-spacing: 0;
    margin-top: 25px;
  }
  .form-value {
    display: flex;
    flex-direction: row;
    font-size: 14px;
    color: #8b8795;
    letter-spacing: 0;
    line-height: 20px;
    @media (max-width: $md) {
      flex-direction: column;
    }
    &.form-title {
      font-size: 18px;
    }
  }
  .section-label {
    opacity: 0.5;
    font-size: 14px;
    color: #8b8795;
    letter-spacing: 0;
  }
}
.downArrow {
  justify-self: flex-end;
  font-size: 23px;
  color: #000 !important;
  margin-right: 25px;
  margin-left: 4px;
  height: 100%;
  display: flex;
  align-items: center;
  align-self: center;
  img {
    transform: rotate(0deg);
    transition-duration: 0.3s;
    @media (max-width: $lg) {
      height: 7px;
      width: 7px;
    }
  }
  img.rotate {
    transform: rotate(180deg);
    transition-duration: 0.3s;
  }
}
</style>
